export const dataHooks = {
    RadioOptionContainer: 'Radio-option-container',
    RadioContainer: 'Radio-container',
    RadioContent: 'Radio-content',
    RadioItem: 'Radio-item',
};
export const dataAttr = {
    DISPLAY: 'data-display',
};
//# sourceMappingURL=constants.js.map